import routes from 'global/Constants/routes';
import { lazy } from 'react';

const LTLSteps = lazy(() => import('../../pages/dashboard/LTL/LTLSteps'));
const LTLDetail = lazy(() => import('../../pages/dashboard/LTL/detail/LTLDetail'));
const LTLOrderList = lazy(() => import('../../pages/dashboard/LTL/List/LTLOrderList'));
const LTLOrderDetail = lazy(() => import('../../pages/dashboard/LTL/detail/LTLDetails'));
const LTLPrintBarcode = lazy(() => import('../../pages/dashboard/LTL/LTLPrintBarcode/LTLPrintBarcode'));

export const LTLRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.ltlPrintBarcode.path,
    component: LTLPrintBarcode,
    isPrivate: routes.ltlPrintBarcode.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.ltlOrderDetail.path,
    component: LTLOrderDetail,
    isPrivate: routes.ltlOrderDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },

  {
    path: routes.ltlOrderList.path,
    component: LTLOrderList,
    isPrivate: routes.ltlOrderList.isPrivate,
    accessRole: hasAccessLevel(10),
  },

  {
    path: routes.ltlDetail.path,
    component: LTLDetail,
    isPrivate: routes.ltlDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.ltlSteps.path,
    component: LTLSteps,
    isPrivate: routes.ltlSteps.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
